import { render, staticRenderFns } from "./BaseQuestionType.vue?vue&type=template&id=352861b9&"
import script from "./BaseQuestionType.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports